import type { TagCount } from './tags.js';

/**
 * Список всех тегов на виду, с числом незакрытых в каждом (3.10.2), клик
 * фильтрует (3.10.3).
 *
 * Стоит под шапкой, а не прячется в меню: «на виду» — это и есть требование, а
 * тег, который надо сначала найти, перестаёт работать как способ группировки.
 * Ряд прокручивается вбок, чтобы длинный список не отжимал задачи вниз.
 *
 * Счётчики глобальные, по всем спринтам: тег отвечает на вопрос «сколько всего
 * висит по дому», а не «сколько на этой неделе». Поэтому нажатие на тег
 * заодно расширяет поиск на все спринты — иначе список показал бы одну задачу
 * там, где в счётчике стоит пять, и счётчик оказался бы враньём.
 */
export function TagBar({
  tags,
  active,
  onPick,
}: {
  tags: readonly TagCount[];
  active: string | undefined;
  onPick: (tag: string | undefined) => void;
}): React.ReactElement | null {
  if (tags.length === 0) return null;

  return (
    <div className="tagbar" role="group" aria-label="Теги">
      {tags.map(({ tag, open }) => {
        const current = tag === active;
        return (
          <button
            key={tag}
            type="button"
            className="tagbar__item"
            aria-pressed={current}
            // Имя проговаривает и число, и назначение: голое «поездка 2» в
            // озвучке ничего не значит, а такой же чип есть на каждой строке
            // задачи — их надо отличать.
            aria-label={`Тег ${tag}, незакрытых: ${String(open)}`}
            // Нажатие на включённый тег снимает фильтр: иначе выключить его
            // можно только в другом месте экрана, и это ищут глазами.
            onClick={() => onPick(current ? undefined : tag)}
          >
            #{tag}
            {open > 0 && <span className="count">{open}</span>}
          </button>
        );
      })}
    </div>
  );
}
